import { Fragment, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Error, Label } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { useSenderDetailsContext } from 'pages/settings/pages/rcsV2/pages/create/SenderDetails/hooks/useSenderDetailsContext'

export const BrandTermsSection: FC = observer(() => {
  const {
    brandTermsStore: {
      privacyPolicyUrl,
      setPrivacyPolicyUrl,
      privacyPolicyError,
      validatePrivacyPolicyUrl,
      termsAndConditionsUrl,
      setTermsAndConditionsUrl,
      termsAndConditionsError,
      validateTermsAndConditionsUrl,
    },
  } = useSenderDetailsContext()

  return (
    <Fragment>
      <Box display={'grid'} gap={'8px'} mt={'40px'}>
        <Label
          height={16}
          label={{
            text: 'Privacy policy URL',
            textColor: 'var(--content-primary-primary)',
            horizontal: true,
          }}
        />
        <TextField
          size='medium'
          variant='stroke'
          error={privacyPolicyError}
          InputProps={{
            placeholder: 'https://',
          }}
          value={privacyPolicyUrl}
          onChange={setPrivacyPolicyUrl}
          onBlur={validatePrivacyPolicyUrl}
        />
        <Error type='text' error={privacyPolicyError} />
      </Box>
      <Box display={'grid'} mt={'24px'} gap={'8px'}>
        <Label
          height={16}
          label={{
            textColor: 'var(--content-primary-primary)',
            text: 'Terms and conditions URL',
            horizontal: true,
          }}
        />
        <TextField
          size='medium'
          variant='stroke'
          error={termsAndConditionsError}
          InputProps={{
            placeholder: 'https://',
          }}
          value={termsAndConditionsUrl}
          onChange={setTermsAndConditionsUrl}
          onBlur={validateTermsAndConditionsUrl}
        />
        <Error type='text' error={termsAndConditionsError} />
      </Box>
    </Fragment>
  )
})
